import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=2ec0ce98&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthSignupForm: require('/opt/cargo.front/src/components/auth/signup-form.vue').default,BaseErrorModal: require('/opt/cargo.front/src/components/base/error-modal.vue').default})
